module.exports = __webpack_public_path__ + "static/media/slash-image.7ca72633.png";